import React from 'react';
import { Logo } from './Logo';
export function BrandHeader() {
  return <div className="fixed top-3 right-4 sm:top-5 sm:right-6 z-40 flex items-center gap-2 pointer-events-none select-none" data-id="element-8">
      <Logo className="w-6 h-6 sm:w-7 sm:h-7 opacity-80" data-id="element-9" />
      <span className="text-white/70 text-xs sm:text-sm font-medium tracking-wide hidden sm:inline" data-id="element-10">
        Magic Patterns
      </span>
    </div>;
}